import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import _ from "lodash";
import DataCompareService from "../../../../../../../../services/DataCompareService";
import {Container, Row, Spinner} from "react-bootstrap";
import TitleAndSwitchBox from "../../../../../../../common/dataView/TitleAndSwitchBox";
import DataUtils from "../../../../../../common/utils/DataUtils";
import styled from "styled-components";
import RecipeDataView from "../../../../../../common/jsonDynamic/component/RecipeDataView";
import {value} from "lodash/seq";
import ProductJsonAxiosService from "../../../../../../common/jsonDynamic/service/ProductJsonAxiosService";
import {toast} from "react-toastify";

const SimpleButton = styled.button`
  font-size: 14px;
  padding: 7px 10px;
  color: ${(props) => props.enabled ? "#fc7242" : "#c2c2c2"};
  border: 1px solid ${(props) => props.enabled ? "#fc7242" : "#c2c2c2"};
  transition: all ease-in-out 0.2s;
  border-radius: 10px;
  background-color: white;
  
  &:focus {
    outline: none;
  }
  
  &:hover {
    background-color: ${(props) => props.enabled ? "#ffeee6" : "white"};
  }
`;

const SimpleGreyButton = styled.button`
  font-size: 14px;
  padding: 7px 10px;
  color: ${(props) => props.enabled ? "#757575" : "#c2c2c2"};
  border: 1px solid ${(props) => props.enabled ? "#757575" : "#c2c2c2"};
  transition: all ease-in-out 0.2s;
  border-radius: 10px;
  background-color: white;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${(props) => props.enabled ? "#ebebeb" : "white"};
  }
`;

const RecipeView = ({ currentMenuDetail, boothJsonVersionId, productJsonSchema, refreshMenuList }) => {

    const { t } = useTranslation();
    const { franchiseId, menuId } = useParams();

    /* states */
    const [requestBody, setRequestBody] = useState({});
    const [fixedRequestBody, setFixedRequestBody] = useState({});
    const [isValidMap, setIsValidMap] = useState({});
    const [isValid, setIsValid] = useState(false);
    const [isEdited, setIsEdited] = useState(false);

    /* isLoading */
    const [isSaveLoading, setIsSaveLoading] = useState(false);

    /* alert */
    const AlertInner = (message) => {
        return (
            <div
                style={{
                    width: '100%',
                    textAlign: 'left'
                }}
            >
                <span
                    style={{
                        color: '#757575',
                        fontSize: '14px'
                    }}
                >
                    {message}
                </span>
            </div>
        );
    };

    /* initialize */
    const initializeStates = async () => {
        let newRequestBody = {};
        let newIsValidMap = {};

        /** isEdited */
        await setIsEdited(false);

        /** isValid */
        await setIsValid(true);

        /** requestBody, fixedRequestBody */
        /** isValidMap */
        newRequestBody['franchiseMenuDetailBoothVersionId'] = boothJsonVersionId;
        newIsValidMap['franchiseMenuDetailBoothVersionId'] = true;
        newRequestBody['franchiseMenuDetailProductJsonVersion'] = productJsonSchema['metadata']['id'];
        newIsValidMap['franchiseMenuDetailProductJsonVersion'] = true;
        /* "franchiseMenuDetailRecipe" */
        let recipeDataObj = JSON.parse(currentMenuDetail['franchiseMenuDetailRecipe']);
        let objectKeys = Object.keys(productJsonSchema['spec']['attributes']);
        objectKeys.map(objectKey => {
            newRequestBody[objectKey] = recipeDataObj['attributes'][objectKey];
            newIsValidMap[objectKey] = true;
        });
        await setIsValidMap(newIsValidMap);
        await setFixedRequestBody(newRequestBody);
        await setRequestBody(newRequestBody);
    };

    const formatRequestBody = (prevRequestBody) => {
        let newRequestBody = {};
        let newRecipe = {};
        let prevRequestBodyCopy = _.cloneDeep(prevRequestBody);

        newRequestBody['franchiseMenuDetailBoothVersionId'] = prevRequestBodyCopy['franchiseMenuDetailBoothVersionId'];
        delete prevRequestBodyCopy['franchiseMenuDetailBoothVersionId'];

        newRequestBody['franchiseMenuDetailProductJsonVersion'] = prevRequestBodyCopy['franchiseMenuDetailProductJsonVersion'];
        delete prevRequestBodyCopy['franchiseMenuDetailProductJsonVersion'];

        newRecipe['attributes'] = prevRequestBodyCopy;
        newRequestBody['franchiseMenuDetailRecipe'] = JSON.stringify(newRecipe);

        return newRequestBody;
    };

    const putMenuDetail = async () => {
        await setIsSaveLoading(true);
        try {
            let formattedRequestBody = formatRequestBody(requestBody);
            const onSuccessCallback = async (res) => {
                toast.success(AlertInner(t("message.saved")));
                /* refresh all */
                await refreshMenuList();
                await setIsSaveLoading(false);
            };
            const onFailureCallback = async (e) => {
                console.log(e);
                throw { message: "Failed to save a new default menu.", alertMsgKey: "saveError" };
            };
            await ProductJsonAxiosService.saveOrGenerateMenuDetail(franchiseId, menuId, formattedRequestBody, onSuccessCallback, onFailureCallback);
        } catch (err) {
            console.log(err);
            /* alert */
            let message = t(`menu.franchiseMenu.recipeInfo.menuRecipe.message.error.${err['alertMsgKey']}`);
            toast.error(AlertInner(message));
            /* roll-back */
            setIsSaveLoading(false);
        }
    };

    /* effects */
    useEffect(() => {
        initializeStates();
    }, [currentMenuDetail, boothJsonVersionId, productJsonSchema, menuId]);

    useEffect(() => {
        setIsEdited(!_.isEqual(requestBody, fixedRequestBody));
    }, [requestBody]);

    useEffect(() => {
        setIsValid(DataCompareService.checkIsAllTrue(isValidMap));
    }, [isValidMap]);

    return (
        <Container fluid>
            <Row>
                {/* json recipe view */}
                {/* fixed height */}
                <div
                    style={{
                        width: '100%',
                        height: '500px',
                        overflow: 'auto',
                        border: '1px solid #ebebeb',
                        borderRadius: '10px',
                        padding: '10px'
                    }}
                >
                    {
                        Object.keys(productJsonSchema['spec']['attributes']).map(fieldKey => {
                            return (
                                <RecipeDataView
                                    key={productJsonSchema['metadata']['id'] + productJsonSchema['spec']['attributes'][fieldKey][t("language.dataKey.boothControl.json.label")]}
                                    title={productJsonSchema['spec']['attributes'][fieldKey][t("language.dataKey.boothControl.json.label")]}
                                    fieldKey={fieldKey}
                                    validator={productJsonSchema['spec']['attributes'][fieldKey]['validator']}
                                    isCategorical={productJsonSchema['spec']['attributes'][fieldKey]['isCategorical']}
                                    data={requestBody[fieldKey]}
                                    updateData={(value) => DataUtils.updateHelper(setRequestBody, fieldKey, value)}
                                    isValidMap={isValidMap}
                                    updateIsValidMap={(value) => DataUtils.updateHelper(setIsValidMap, fieldKey, value)}
                                    isForEdit={true}
                                    unitOfValue={productJsonSchema['spec']['attributes'][fieldKey]['unitOfValue']}
                                />
                            );
                        })
                    }
                </div>
            </Row>
            <Row>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: '15px'
                    }}
                >
                    <div
                        style={{
                            marginLeft : 'auto',
                            display: 'inline-flex',
                            alignItems: 'center'
                        }}
                    >
                        {/* initialize button */}
                        <SimpleGreyButton
                            enabled={isEdited}
                            onClick={() => {
                                if (isEdited) {
                                    initializeStates();
                                }
                            }}
                        >
                            {t("menu.franchiseMenu.recipeInfo.menuRecipe.button.init")}
                        </SimpleGreyButton>
                    </div>
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            marginLeft: '10px'
                        }}>
                        {/* save button */}
                        <SimpleButton
                            enabled={isEdited && isValid && !isSaveLoading}
                            onClick={() => {
                                if (isEdited && isValid && !isSaveLoading) {
                                    putMenuDetail();
                                }
                            }}
                        >
                            {
                                isSaveLoading ?
                                    <Spinner size={"sm"} />
                                    :
                                    <>
                                        {t("button.save")}
                                    </>
                            }
                        </SimpleButton>
                    </div>
                </div>
            </Row>
        </Container>
    );
};

export default RecipeView;